module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeDropdown),
      expression: "closeDropdown"
    }],
    staticClass: "input-group multi-select",
    class: {
      'show': _vm.openSuggestion
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "autocomplete": "off",
      "name": "hidden",
      "type": "text"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selection),
      expression: "selection"
    }],
    ref: "search",
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.placeholder,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm._s(_vm.selection)
    },
    on: {
      "keydown": [_vm.setOpen, function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        $event.preventDefault();
        _vm.enter($event)
      }, function($event) {
        if (_vm._k($event.keyCode, "up", 38)) { return; }
        _vm.up($event)
      }, function($event) {
        if (_vm._k($event.keyCode, "tab", 9)) { return; }
        _vm.tab($event)
      }, function($event) {
        if (_vm._k($event.keyCode, "down", 40)) { return; }
        _vm.down($event)
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.selection = $event.target.value
      }, _vm.search]
    }
  }), _vm._v(" "), (_vm.selection) ? _c('div', {
    staticClass: "input-group-btn",
    attrs: {
      "id": "cancel"
    }
  }, [_c('button', {
    staticClass: "btn btn-blank",
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.clear($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showempty) ? _c('div', {
    staticClass: "input-group-btn",
    attrs: {
      "id": "dropdown"
    }
  }, [_c('button', {
    staticClass: "btn btn-trigger view-all",
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.triggerClick($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  })])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    class: {
      'hide-border': !_vm.add && !_vm.matches.length
    }
  }, [(_vm.add) ? _c('li', {
    staticClass: "add-option",
    on: {
      "click": function($event) {
        _vm.$emit('addClick')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("  " + _vm._s(_vm.addText))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.matches), function(m, i) {
    return _c('li', {
      key: i,
      class: {
        'active': _vm.isActive(i)
      },
      on: {
        "click": function($event) {
          _vm.suggestionClick(i)
        }
      }
    }, [_vm._v(_vm._s(m))])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d42e828!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/Autocomplete.vue
// module id = 375
// module chunks = 0